import type { FC } from 'react';
import { cn } from '@/utils/cn';

interface ModalBodyProps {
  children: React.ReactNode;
  bodyClassName?: string;
}

const ModalBody: FC<ModalBodyProps> = ({ children, bodyClassName }) => (
  <div
    className={cn(
      'grid grid-rows-[1fr_auto] px-4 lg:px-6.5 max-w-106 w-full mx-auto h-full pb-6.5',
      bodyClassName,
    )}
  >
    {children}
  </div>
);

ModalBody.displayName = 'ModalBody';

export default ModalBody;
